import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode, getTemplateNodeReturns} from "@cm/template-nodes"
import type {TemplateNodeDefinition} from "@cm/template-nodes"
import {MattressNode} from "#mattress/nodes/mattress-node"
import {MattressMaterialAssignment} from "#mattress/nodes/mattress-material-assignment"

export type MattressMaterialAssignmentsParameters = Record<string, MattressMaterialAssignment | null>

const definition: TemplateNodeDefinition<MattressMaterialAssignmentsParameters> = {
    nodeClass: "MattressMaterialAssignments",
    validation: {
        parameters: z.record(z.string(), z.nullable(graphNode(MattressMaterialAssignment))),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MattressMaterialAssignments extends MattressNode<MattressMaterialAssignmentsParameters> {
    public override get definition() {
        return definition
    }
}
